<div
  class="media-links"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <p>{{ section.text }}</p>
  <app-media-links></app-media-links>
</div>
